export const sourceActionTypes = {
    /**
     * Sources get constants :
     */
    GET_SOURCES_REQUEST: 'SOURCES_GET_SOURCES_REQUEST',
    GET_SOURCES_SUCCESS: 'SOURCES_GET_SOURCES_SUCCESS',
    GET_SOURCES_FAILURE: 'SOURCES_GET_SOURCES_FAILURE',

    /**
     * Set Current Source
     */
    SET_CURRENT_SOURCE: 'SOURCE_SET_CURRENT_SOURCE',

    /**
     * Source deactivate constants
     * Reducer : currentSource.reducer
     */
    DEACTIVATE_SOURCE_REQUEST: 'SOURCES_DEACTIVATE_SOURCE_REQUEST',
    DEACTIVATE_SOURCE_SUCCESS: 'SOURCES_DEACTIVATE_SOURCE_SUCCESS',
    DEACTIVATE_SOURCE_FAILURE: 'SOURCES_DEACTIVATE_SOURCE_FAILURE',

    /**
     * Source activate constants
     * Reducer : currentSource.reducer
     */
    ACTIVATE_SOURCE_REQUEST: 'SOURCES_ACTIVATE_SOURCE_REQUEST',
    ACTIVATE_SOURCE_SUCCESS: 'SOURCES_ACTIVATE_SOURCE_SUCCESS',
    ACTIVATE_SOURCE_FAILURE: 'SOURCES_ACTIVATE_SOURCE_FAILURE',

    /**
     * Source validate constants
     * Reducer : order.reducer
     */
    VALIDATE_SOURCE_REQUEST: 'SOURCES_VALIDATE_SOURCE_REQUEST',
    VALIDATE_SOURCE_SUCCESS: 'SOURCES_VALIDATE_SOURCE_SUCCESS',
    VALIDATE_SOURCE_FAILURE: 'SOURCES_VALIDATE_SOURCE_FAILURE',

    /**
     * Order sources (Create New) constants
     * Reducer : order.reducer
     */
    ORDER_SOURCE_REQUEST: 'SOURCES_ORDER_SOURCE_REQUEST',
    ORDER_SOURCE_RESET  : 'SOURCES_ORDER_SOURCE_RESET',
    ORDER_SOURCE_SUCCESS: 'SOURCES_ORDER_SOURCE_SUCCESS',
    ORDER_SOURCE_FAILURE: 'SOURCES_ORDER_SOURCE_FAILURE',

    /**
     * Edit sources
     * Reducer : source.reducer & currentSource.reducer
     */
    EDIT_SOURCE_REQUEST: 'SOURCES_EDIT_SOURCE_REQUEST',
    EDIT_SOURCE_SUCCESS: 'SOURCES_EDIT_SOURCE_SUCCESS',
    EDIT_SOURCE_FAILURE: 'SOURCES_EDIT_SOURCE_FAILURE',

    /**
     * Upload Source
     * Reducer : uploads.reducer
     */
    GET_UPLOAD_PACKET_REQUEST: 'SOURCES_GET_UPLOAD_PACKET_REQUEST',
    GET_UPLOAD_PACKET_SUCCESS: 'SOURCES_GET_UPLOAD_PACKET_SUCCESS',
    GET_UPLOAD_PACKET_FAILURE: 'SOURCES_GET_UPLOAD_PACKET_FAILURE',
    UPLOAD_SOURCE_REQUEST: 'SOURCES_UPLOAD_SOURCE_REQUEST',
    UPLOAD_SOURCE_SUCCESS: 'SOURCES_UPLOAD_SOURCE_SUCCESS',
    UPLOAD_SOURCE_FAILURE: 'SOURCES_UPLOAD_SOURCE_FAILURE',
    UPLOAD_SOURCE_RESET: 'SOURCES_UPLOAD_SOURCE_RESET',
};